<div *ngIf="!disabled" fxLayout="column" fxLayoutGap="10px" class="w-100">
    <app-table-filter
        [filtersTogglesInOnBtn]="true"
        [inGlobalFilter]="true"
        color="accent"
        class="w-100"
        (filterChange)="onFilterChange($event.filters)"
        #filter
    >
        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space dashboard-tabs-type-filter"
            [ignoreCaching]="true"
            label="Foundation Filter"
            i18n-label
            [property]="GlobalFilterProperty.DASHBOARD_TABS_TYPE"
            [options]="dashboardTabsTypeOptions"
            dashboardTabsTypeFilterRef
        >
        </app-select-filter>
        <app-select-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            class="filter-space"
            label="Type"
            i18n-label="@@type"
            [property]="{
                name: GlobalFilterProperty.SCOPE,
                type: GlobalFilterPropertyType.RESOURCE_TYPE
            }"
            [options]="resourceTypeOptions"
            scopesFilterRef
        >
        </app-select-filter>
        <app-table-search
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            class="align-space"
            searchFilterRef
        ></app-table-search>

        <app-tag-chip-search-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            fxFlex="50%"
            fxFlex.lt-md="100%"
            fxLayoutAlign="start"
            tagsFilterRef
        ></app-tag-chip-search-filter>
        <app-category-chip-search-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            fxFlex="50%"
            fxFlex.lt-md="100%"
            [scope_id]="AppScope.RESOURCES"
            categoriesFilterRef
        ></app-category-chip-search-filter>
        <app-select-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            class="filter-space"
            label="Access role"
            i18n-label
            [property]="GlobalFilterProperty.ACCESS_ROLE"
            [options]="accessRoleOptions"
            resourceAccessRoleFilterRef
        >
        </app-select-filter>
        <app-select-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            class="filter-space"
            label="Resource status"
            i18n-label
            [property]="{
                name: GlobalFilterProperty.STATUS,
                type: GlobalFilterPropertyType.STATUS_RESOURCE
            }"
            [options]="resourceSelectOptions"
            resourceStateFilterRef
        ></app-select-filter>

        <app-table-date-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            color="accent"
            dateFilterRef
        ></app-table-date-filter>

        <app-select-filter
            [inGlobalFilter]="true"
            [ignoreCaching]="true"
            class="filter-space"
            label="Access permission"
            i18n-label
            [property]="GlobalFilterProperty.PERMISSION_TYPE"
            [options]="permissionTypeOptions"
            resourceAccessPermissionsFilterRef
        >
        </app-select-filter>

        <!-- <app-language-filter
            [inGlobalFilter]="true"
            #langFilter
            fxFlex="0 0 auto"
            fxLayout="row"
            [prefLangIds]="customer?.pref_lang_ids"
            langFilterRef
        ></app-language-filter> -->
    </app-table-filter>
</div>
